import React, { useEffect, useState, useContext } from 'react';
import LeftsidePaitent from "../Dashbord/LeftsidePaitent";
import { authContext } from "../Context/AuthContext";
import { Link } from 'react-router-dom';
import Navbar from '../Components/Basic/Navbar';
import ChatBar from '../Components/Chat/Chatbar'; // Import the ChatBar component

export default function SearchDoctor() {
  const [doctor, setDoctor] = useState([]);
  const { isAuth, token, refToken, role } = useContext(authContext);

  useEffect(() => {

  }, []);

  return (
    <div className="bg-dark" style={{ height: "100vh" }}>
      <Navbar />
      <div>
        <div className="row m-5" style={{ maxWidth: "100%" }}>
          <div className="col-3 col-md-3 p-4 bg-white ">
            <LeftsidePaitent />
          </div>
          <div
            className="col-9 col-md-9 p-4"
            style={{
              border: "15px solid yellow ",
              height: "80vh",
              backgroundColor: "#6c757d",
            }}
          >
            {/* Render the chat bar component */}
            <div className="chat-bar-container">
              <ChatBar />
            </div>

            {/* Remaining content */}
          </div>
        </div>
      </div>
    </div>
  );
}
